import { trackEvent } from 'utils/tracking';
import { useStore } from 'zustand';
import {
  FinanceOption,
  ModelType,
  PrivateDistance,
  TrimType,
} from '../../../types';
import { formatNumber } from '../../../utils/helpers';
import CarouselCardRow from './CarouselCardRow';
import { getStoreByKey } from './store/CarouselStore';
import { CarouselFieldsEnum } from './types/CarouselTypes';

interface Props {
  trim: TrimType;
  model: ModelType;
  uniqId: string;
}

const CarouselPrivateRows = ({ trim, model, uniqId }: Props) => {
  const {
    options,
    showPrivateMileages,
    selectedFinanceOption,
    selectedPrivateDistance,
  } = useStore(getStoreByKey(uniqId));

  const shouldRenderInPriceList = Boolean(
    !options &&
    (!selectedFinanceOption || selectedFinanceOption === FinanceOption.PRIVATE),
  );

  const getPrice = () => {
    switch (selectedPrivateDistance) {
      case PrivateDistance.Two:
        return trim.private_leasing[0].manadshyra364500;
      case PrivateDistance.Three:
        return trim.private_leasing[0].manadshyra366000;
      case PrivateDistance.Four:
        return trim.private_leasing[0].manadshyra369000;
      default:
        return trim.private_leasing[0].manadshyra363000;
    }
  };

  return (
    <>
      {trim.private_leasing?.length ? (
        <>
          {shouldRenderInPriceList ||
          options?.fields?.includes(CarouselFieldsEnum.PRIVATE_LEASING) ? (
            <CarouselCardRow
              uniqId={uniqId}
              tooltip={
                model.show_privatleasing
                  ? showPrivateMileages
                    ? '36 månader. Rörlig leasingavgift.'
                    : '36 mån 3000 mil'
                  : null
              }
              label="Privatleasing inkl. serviceavtal ²"
            >
              {model.show_privatleasing ? (
                showPrivateMileages ? (
                  <p>
                    Från {formatNumber(getPrice())} kr/mån (rörlig
                    leasingavgift)
                  </p>
                ) : (
                  <p>
                    Från{' '}
                    {formatNumber(trim.private_leasing[0].manadshyra363000)}{' '}
                    kr/mån
                  </p>
                )
              ) : (
                <p>
                  <a
                    onClick={() =>
                      trackEvent({
                        event: 'find_a_dealer',
                        model,
                        trim,
                      })
                    }
                    href="https://www.kia.com/se/sok-aterforsaljare-verkstad"
                    className="underline"
                  >
                    Kontakta återförsäljare
                  </a>
                  {' för prisuppgift'}
                </p>
              )}
            </CarouselCardRow>
          ) : null}
        </>
      ) : null}
    </>
  );
};

export default CarouselPrivateRows;
